import { programNameIsSupplierPortal } from '../programs/predicates';
import { selectUserPrograms } from './selectors';
import {
    fetchUserAssociatedProperties,
    getDefaultSupplierId,
    getUser
} from "../../utilities/ApiTasks";
import { getKey, readPmsMobileSettings } from "../../utilities/Storage";
import {get, upload} from "../../utilities/SimpleClient";
import moment from "moment/moment";

/**
 * For a Supplier to be a Cleaner the following criteria must be met:
 *
 * 1. be in the "Supplier Programme" on the date,
 *
 * @param user
 * @returns {boolean|boolean}
 */
export const userIsCleaner = (user) =>
    user ? selectUserPrograms(user).some(programNameIsSupplierPortal) : false;

export const userIsSelfEmployed = userIsCleaner;

export const getAssignedSupplierId = async (isSelfEmployed, jobType, userId) => {
    if ( !isSelfEmployed && jobType === 'maintenance_job_in_review' ) {
        return userId
    }

    return await getDefaultSupplierId();
}

/**
 * For a Supplier to be a Field Worker the following criteria must be met:
 *
 * 1. not be in the "Supplier Portal" programme,
 * 2. be in one of the "fieldworker",
 * 3. be marked as "agencyemployed"
 *
 * @param user
 * @returns {Promise<*|boolean>}
 */
export const userIsFieldWorker = async (user) => {
    if (userIsCleaner(user)) {
        return false;
    }

    if (!user.agencyemployed) {
        return false;
    }

    const supplierId = Number(user.id);
    const settings = await readPmsMobileSettings();
    return settings.groups?.some(group => group.fieldWorkers?.some(fieldWorkerId => supplierId === Number(fieldWorkerId))) ?? false;
}

export const userIsOwnerManaged = async () => {
    const userProperties = await fetchUserAssociatedProperties();
    const user = getUser();
    if (!userProperties.length) {
        return false;
    }

    for (const property of userProperties){
        if (getManagementDisplayForSupplierAndProperty(user.id, property) !== 'Owner Management') {
            return false;
        }
    }

    return true;
}

export const getManagementDisplayForSupplierAndProperty = (supplierId, propertyData) => {
    let managementDisplay = 'Owner Management';
    let activity;

    let agencyManagement = false;
    let agencyActivityArray = [];

    let premiumManagement = false;
    let premiumActivityArray = [];

    let suppliers = propertyData.housekeeping.suppliers;

    suppliers.forEach((supplierData)  => {

        // Premium Management
        if (supplierData.activity.indexOf('Premium Management') !== -1) {
            premiumManagement = true;
            activity = supplierData.activity.replace('Premium Management', '').replace('-', '').trim();
            if (activity !== '') {
                premiumActivityArray.push(activity);
            }
            // Agency Management
        } else if (supplierData.activity.indexOf('Agency Management') !== -1) {
            agencyManagement = true;
            activity = supplierData.activity.replace('Agency Management', '').replace('-', '').trim();
            if (activity !== '') {
                agencyActivityArray.push(activity);
            }
        }
    });

    if (premiumManagement) {
        managementDisplay = 'Premium Management';
        if (premiumActivityArray.length > 0) {
            managementDisplay+= ' (' + premiumActivityArray.join(', ') + ')';
        }
    } else if (agencyManagement) {
        managementDisplay = 'Agency Management';
        if (agencyActivityArray.length > 0) {
            managementDisplay+= ' (' + agencyActivityArray.join(', ') + ')';
        }
    }

    return managementDisplay;
}